import { selectors } from '@sloyd/store-base';
import { select, take } from 'saga-ts';

export function* dataGuard() {
  const appState = yield* select(selectors.raw.$rawAppState);
  const { isDataReady } = appState;

  if (!isDataReady) {
    yield take('DATA_READY');
  }

  return true;
}

export function* authGuard() {
  console.time('authGuard');
  const appState = yield* select(selectors.raw.$rawAppState);
  const { isAuthenticated } = appState;

  if (!isAuthenticated) {
    yield take('AUTH_COMPLETED');
  }

  console.timeEnd('authGuard');

  return true;
}
